<div class="modal fade" id="loginModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true" data-backdrop="false">
    <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <div class="pad-0-10" *ngIf="isCoupon">
                    <strong class="">Note!</strong> Please Login to Claim the Coupons.
                </div>
                <button type="button" class="close login-clse" (click)="closePopUp()" #closebtn>
          <span aria-hidden="true" class="login-crss">&times;</span>
        </button>
            </div>

            <div class="modal-body">
                <div class="row mt-4">
                    <div class="col-lg-6 col-md-12 ">
                        <div id="demo" class="carousel slide" data-ride="carousel">
                            <ul class="carousel-indicators">
                                <li data-target="#demo" data-slide-to="0" class="active"></li>
                                <li data-target="#demo" data-slide-to="1"></li>
                                <li data-target="#demo" data-slide-to="2"></li>
                            </ul>
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img src="assets/images/image-regular/login01.jpg" alt="Los Angeles" width="1100" height="500" />
                                    <div class="carousel-caption">
                                        <h3 class="white">Your Travel Booking</h3>
                                        <!-- <p>We had such a great time in LA!</p> -->
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <img src="assets/images/image-regular/login01.jpg" alt="Chicago" width="1100" height="500" />
                                    <div class="carousel-caption">
                                        <h3 class="white">Your Travel Booking</h3>
                                        <!-- <p>Thank you, Chicago!</p> -->
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <img src="assets/images/image-regular/login01.jpg" alt="New York" width="1100" height="500" />
                                    <div class="carousel-caption">
                                        <h3 class="white">Your Travel Booking</h3>
                                        <!-- <p>We love the Big Apple!</p> -->
                                    </div>
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#demo" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#demo" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 ">
                        <div class="tab-content">
                            <div role="tabpanel" class="tab-pane padding-0 active" id="loginTabInDropdown01-01s">
                                <div class="scene scene--card">
                                    <div #forgot class="card" *ngIf="showlogin">
                                        <div class="" *ngIf="forgotPassword">
                                            <div class="text-center lgn-lg">
                                                <br />
                                                <img src="assets/images/logo-white.png" class="center" alt="logo" title="logo" width="200px" />
                                            </div>
                                            <div class="row pl-20 pr-20 ytb-login">
                                                <div class="text-center col-md-12">
                                                    <h4 class="font24 font600 opensans mt-10">Sign in</h4>
                                                    <p class="">with your social network</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="login-with-socials">
                                                        <button class="logingoogle font13" (click)="loginwithGoogle('google')">
                              <img src="assets/images/google.png" alt="Image" class="mr-10" width="20px" />
                              Google
                            </button>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="login-with-socials">
                                                        <button class="btn btn-facebook btn-block font13" (click)="loginwithGoogle('facebook')">
                              <i class="fab fa-facebook-f"></i> Facebook
                            </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <form [formGroup]="loginForm" class="form-login">
                                                <div class="form-inner">
                                                    <div class="text-seperator">
                                                        <span>or</span>
                                                    </div>




                                                    <ng-container *ngIf="showErrorMessage && errorMessageInfo">
                                                        <div class="row alert alert-danger" *ngFor="let err of errorMessageInfo">
                                                            {{ err }}
                                                        </div>
                                                    </ng-container>

                                                    <ng-container *ngIf="showSuccessMessage && errorMessageInfo">
                                                        <div class="alert alert-success" *ngFor="let err of errorMessageInfo">
                                                            {{ err }}
                                                        </div>
                                                    </ng-container>
                                                    <br />
                                                    <button *ngIf="isConfirmationEmail" type="submit" class="btn btn-primary btn-block font15" (click)="resendEmailConfirmation()">
                            Click Here To Resend Email Confirmation
                          </button>






                                                    <div class="form-group ytb-lgn">
                                                        <label class="black">Username <span class="red">*</span></label>
                                                        <input formControlName="userId" id="login_username" class="form-control" [ngClass]="{
                                'is-invalid': submitted && f.userId.errors
                              }" placeholder="UserId" type="text" />
                                                        <div *ngIf="submitted && f.userId.errors" class="invalid-feedback">
                                                            <div *ngIf="f.userId.errors.required">
                                                                <b class="font14">userId is required</b>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br />
                                                    <div class="form-group ytb-lgn">
                                                        <label class="black">Password <span class="red">*</span></label>
                                                        <input formControlName="password" id="login_password" [ngClass]="{
                                'is-invalid': submitted && f.password.errors
                              }" class="form-control" placeholder="Password" type="password" />
                                                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                                            <div *ngIf="f.password.errors.required">
                                                                <b class="font14">Password is required</b>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row gap-5 mt-10">
                                                        <div class="pay-5">
                                                            <div class="custom-control custom-checkbox mt-1 loginrmbr">
                                                                <!-- <input type="checkbox" class="custom-control-input"
                                                                    id="loginForm-02-checkbox-in-tab"
                                                                    formControlName="isRememberMe">
                                                                <label class="custom-control-label font14 line-145"
                                                                    for="loginForm-02-checkbox-in-tab">Remember
                                                                    me</label> -->

                                                                <p-checkbox binary="true" [formControl]="
                                    loginForm.controls['isRememberMe']
                                  ">
                                                                </p-checkbox>
                                                                <label class="text-orange" style="position: relative; top: 2px">Remember me</label>
                                                            </div>
                                                        </div>
                                                        <div class="pay-5 text-right">
                                                            <div class="nav text-right d-inline-block">

                                                                <!-- text-orange text-underline font13 btn btn-link  forgotpassward cursor -->
                                                                <a (click)="loadComponent('forgotpassword')" class="btn btn-link  text-orange text-dark cursor font13 forgotpassword">Forgot
                                  password?</a>






                                                                <!-- <div class="" role="alert">
                                    <span class="text-black">    Don't have an account?</span>
                                    <a #signin class="font600 text-orange text-underline cursor" data-toggle="modal" data-target="#singnupModal" (click)="navigateToSignup()" href="">
                                        Create an account
</a>
                                </div> -->



                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="mt-10">
                                                        <button type="submit" (click)="submitLogin()" class="btn btn-primary btn-block font15">
                              Login
                            </button>
                                                    </div>
                                                    <!-- <div class="mt-10 text-center">
                                                        <h6 class="text-center" style="
                                
                                margin-top: 15px !important;
                              ">
                                                            <b><a id="signuplink" class="font600 text-orange text-underline cursor "
                                  (click)="navigateToSignup()" data-toggle="modal" data-target="#singnupModal">Create an account</a></b>
                                                        </h6>
                                                    </div> -->

                                                    <div class=" ">
                                                        <div class="form-group mt-2">
                                                            <div>
                                                                <div class="" role="alert">
                                                                    <span class="text-black">    Don't have an account?</span>
                                                                    <a #signin class="font600 text-orange text-underline cursor" data-toggle="modal" data-target="#singnupModal" (click)="navigateToSignup()" href="">
                                                                        Create an account
                                </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </form>
                                        </div>
                                        <!-- <ng-template #signupcontainer></ng-template> -->

                                        <div class="card__face card__face--back">
                                            <ng-template #load></ng-template>
                                        </div>
                                    </div>


                                    <div *ngIf="showreset" class="card">
                                        <form [formGroup]="resetForm" class="form-login">
                                            <div class="text-center">
                                                <br /><img alt="New York" class="center" src="assets/images/logo-white.png" alt="logo" title="logo" width="200px" />
                                            </div>
                                            <div class="form-inner" style="height: 450px; padding-top: 13%">
                                                <div *ngIf="password" class="alert alert-success">
                                                    Password Updated Successfully
                                                </div>
                                                <div class="form-group ytb-lgn">
                                                    <label class="black left">Userid <span class="red">*</span></label>
                                                    <input formControlName="userId" id="login_username" class="form-control" [ngClass]="{
                              'is-invalid': submitted && f.userId.errors
                            }" placeholder="userId" type="text" />
                                                    <div *ngIf="submitted && f.userId.errors" class="invalid-feedback">
                                                        <div *ngIf="f.userId.errors.required">
                                                            <b>userId is required</b>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br />
                                                <div class="form-group ytb-lgn">
                                                    <label class="black">Password <span class="red">*</span></label>
                                                    <input formControlName="password" id="login_password" [ngClass]="{
                              'is-invalid': submitted && f.password.errors
                            }" class="form-control" placeholder="Password" type="password" />
                                                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                                        <div *ngIf="f.password.errors.required">
                                                            <b>Password is required</b>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-group mt-10 ytb-lgn">
                                                    <label class="black">Confirm Password <span class="red">*</span></label>
                                                    <input formControlName="confirmpassowrd" id="login_password" [ngClass]="{
                              'is-invalid':
                                submitted && f.confirmpassowrd.errors
                            }" class="form-control" placeholder="Confirm Passowrd" type="password" />
                                                    <div *ngIf="submitted && f.confirmpassowrd.errors" class="invalid-feedback">
                                                        <div *ngIf="f.confirmpassowrd.errors.required">
                                                            <b>confirmpassowrd is required</b>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="mt-10">
                                                    <button type="submit" class="btn btn-primary btn-block btn-round" (click)="resetlogin()">
                            Submit
                          </button>
                                                </div>
                                                <div class="mt-10">
                                                    <a class="btn btn-default btn-block btn-round text-dark">Cancel</a>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <!-- <div class="form-login">
                                    <div class="text-center">
                                        <br>
                                        <img src="assets/images/logo-white.png" class="center" alt="New York" width="200px">
    
                                    </div>


                                    </form>
    
                                </div> -->
                                    <ngx-spinner bdcolor="rgba(255,255,255, 0.9)" [fullScreen]="false" type="ball-clip-rotate-multiple" size="medium"></ngx-spinner>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>